<template>
  <section class="section is-fullheight animated preFadeInUp fadeInUp">
    <div class="container">
      <!-- Title -->

      <div>
        <div class="section-title-wrapper has-text-centered mt-40">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-layers"></i>
          </div>
          <div>
            <h6
              class="clean-section-title has-text-black has-text-weight-bold is-small"
            >
              صندوق الطلبات
            </h6>
            <h2
              class="subtitle is-5 pt-10 pb-10 has-text-black has-text-weight-bold"
            >
              اختر نوع الخدمة
            </h2>
          </div>
        </div>
      </div>

      <div class="columns is-vcentered mt-40">
        <div class="column">
          <div
            class="flex-card icon-card light-bordered hover-inset padding-20"
            @click="
              makeRequest(
                'الفيزا',
                '1',
                'vs/customerRequests/',
                '/vs/getNotifiction/'
              )
            "
          >
            <img
              class="pr-10"
              src="~/../assets/images/illustrations/icons/landing-v1/visa.png"
              alt
            />
            <div
              class="subtitle is-5 pt-10 pb-10 has-text-black has-text-weight-bold mt-10"
            >
              طلبات الفيزا
            </div>
          </div>
        </div>
        <div class="column">
          <div
            class="flex-card icon-card light-bordered hover-inset padding-20"
            @click="
              makeRequest(
                'تجوال',
                '2',
                'zad/customerRequests/',
                '/zad/getNotifiction/'
              )
            "
          >
            <img
              class="pr-10"
              src="~/../assets/images/illustrations/icons/landing-v1/alzaad.png"
              alt
            />
            <div
              class="subtitle is-5 pt-10 pb-10 has-text-black has-text-weight-bold mt-10"
            >
              طلبات تجوال
            </div>
          </div>
        </div>
        <div class="column">
          <div
            class="flex-card icon-card light-bordered hover-inset padding-20"
            @click="
              makeRequest(
                'أرباب الأسر',
                '4',
                'familyfcp/customerRequests/',
                '/familyfcp/getNotifiction/'
              )
            "
          >
            <img
              class
              src="~/../assets/images/illustrations/icons/landing-v1/cash.svg"
              alt
            />
            <div
              class="subtitle is-5 pt-10 pb-10 has-text-black has-text-weight-bold mt-10"
            >
              طلبات مالية
            </div>
          </div>
        </div>

        <div class="column">
          <div
            class="flex-card icon-card light-bordered hover-inset padding-20"
            @click="
              makeRequest(
                'موبي كاش',
                '3',
                'mobi/customerRequests/',
                '/mobi/getNotifiction/'
              )
            "
          >
            <img
              class
              src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png"
              alt
            />
            <div
              class="subtitle is-5 pt-10 pb-10 has-text-black has-text-weight-bold mt-10"
            >
              طلبات موبي كاش
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "portal",

  data() {
    return {};
  },
  methods: {
    makeRequest(actionstring, serviceid, url, history) {
      this.$router.push({
        name: "Requestinboxdetailed",
        params: {
          requeststring: actionstring,
          requesturl: url,
          serviceid: serviceid,
          historyurl: history,
        },
      });
    },
  },
};
</script>
